<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.8761 11.2152C20.8401 11.2422 17.3071 13.9952 13.0551 11.1642C8.68907 8.25725 4.48807 9.92625 2.87607 11.2152C2.44407 11.5602 2.37407 12.1892 2.71907 12.6212C3.06307 13.0512 3.69307 13.1222 4.12407 12.7772C4.15907 12.7492 7.69207 9.99625 11.9451 12.8282C13.7251 14.0132 15.4771 14.4382 17.0371 14.4382C19.3051 14.4382 21.1691 13.5412 22.1241 12.7772C22.5561 12.4322 22.6261 11.8032 22.2811 11.3722C21.9381 10.9412 21.3061 10.8712 20.8761 11.2152Z"
      fill="white" />
    <g opacity="0.4">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.8761 16.9464C20.8401 16.9744 17.3071 19.7264 13.0551 16.8954C8.68907 13.9884 4.48807 15.6574 2.87607 16.9464C2.44407 17.2914 2.37407 17.9204 2.71907 18.3524C3.06307 18.7824 3.69307 18.8534 4.12407 18.5084C4.15907 18.4804 7.69207 15.7264 11.9451 18.5594C13.7251 19.7444 15.4771 20.1694 17.0371 20.1694C19.3051 20.1694 21.1691 19.2724 22.1241 18.5084C22.5561 18.1634 22.6261 17.5344 22.2811 17.1034C21.9381 16.6724 21.3061 16.6024 20.8761 16.9464Z"
        fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.12636 7.05833C4.16136 7.03033 7.69736 4.27033 11.9453 7.11033C13.7253 8.29533 15.4773 8.71933 17.0373 8.71933C19.3053 8.71933 21.1693 7.82233 22.1243 7.05933C22.5563 6.71433 22.6263 6.08533 22.2813 5.65333C21.9383 5.22333 21.3063 5.15233 20.8763 5.49633C20.8403 5.52533 17.3043 8.27733 13.0563 5.44633C8.69236 2.53033 4.48936 4.20533 2.87436 5.49733C2.44336 5.84333 2.37436 6.47333 2.72036 6.90333C3.06536 7.33533 3.69436 7.40533 4.12636 7.05833Z"
        fill="white" />
    </g>
  </svg>
</template>
